import { ViewportScroller } from '@angular/common';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PaginationComponent implements OnInit {
    public paginationArry: string[] = ['1'];
    public currentPage: number = 1;
    public maxCount: number = 0;
    public pages: number = 0;

    @Input('searchString') searchString: string = '';

    constructor(
        private readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly viewportScroller: ViewportScroller
    ) {}

    ngOnInit(): void {}

    public init(maxCount: number, limit: number) {
        this.maxCount = maxCount;
        this.pages = Math.ceil(this.maxCount / limit);
    }

    public changePagination(currentPage: number) {
        this.paginationArry = [];
        const pagesToShow = 5; // Number of pages to show around the current page

        if (this.pages <= pagesToShow) {
            // If total pages are less than or equal to pagesToShow, show all pages
            for (let i = 1; i <= this.pages; i++) {
                this.paginationArry.push(i.toString());
            }
        } else {
            // Always show the first page if not on the first set of pages
            if (currentPage > 3) {
                this.paginationArry.push('1');
                this.paginationArry.push('...');
            }

            // Determine the start and end index for pagination
            let startIndex = Math.max(currentPage - 2, 1);
            let endIndex = Math.min(startIndex + pagesToShow - 1, this.pages);

            // Adjust startIndex if we're near the end
            if (endIndex === this.pages) {
                startIndex = Math.max(this.pages - pagesToShow + 1, 1);
            }

            // Generate the pagination numbers
            for (let i = startIndex; i <= endIndex; i++) {
                this.paginationArry.push(i.toString());
            }

            // Show the last page and an ellipsis if not at the end
            if (endIndex < this.pages) {
                this.paginationArry.push('...');
                this.paginationArry.push(this.pages.toString());
            }
        }

        this.currentPage = currentPage;
        this.viewportScroller.scrollToPosition([0, 0]);
    }

    previous() {
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: this.getQueryParams((this.currentPage - 1).toString()),
            queryParamsHandling: 'merge'
        });
    }

    next() {
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: this.getQueryParams((this.currentPage + 1).toString()),
            queryParamsHandling: 'merge'
        });
    }

    onNumberClick() {
        // do nothing
    }

    getQueryParams(page: string) {
        let params: any = {
            page: Number(page)
        };
        if (this.searchString) {
            params.search = this.searchString;
        }
        return params;
    }

    isActivePage(index: string) {
        if (this.currentPage.toString() === index) {
            return 'inline-flex items-center border-t-2 border-blue-500 px-4 pt-4 text-sm font-medium text-blue-600';
        } else {
            return 'inline-flex items-center border-t-2 border-transparent px-4 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700';
        }
    }
}
